import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import Bande from '../components/Bande';
import TitreSection from '../components/TitreSection';
import { ListeFaq } from '../components/Faq';
import SectionContact from '../components/SectionContact';
import { FAQ, ENTREPRISE } from '../data/site';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQ.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.r },
  })),
};

export default function PageFaq() {
  const categories = [...new Set(FAQ.map((f) => f.cat))];

  return (
    <>
      <Seo
        titre="Questions fréquentes | Location d'engins BATI SELECT TP"
        description="CACES, livraison, délais, assurance, tarifs, état des lieux : toutes les réponses aux questions des professionnels qui louent nos engins en Île-de-France."
        jsonLd={jsonLd}
      />

      <section className="bg-nuit text-white relative overflow-hidden">
        <div className="absolute inset-0 trame-diagonale" aria-hidden="true" />
        <div className="conteneur relative py-14 sm:py-16">
          <h1 className="font-display uppercase text-[36px] sm:text-[48px] leading-[1] max-w-3xl">
            Vos questions, nos <span className="mot-degrade">réponses</span>
          </h1>
          <p className="mt-5 text-white/75 max-w-2xl text-[18px]">
            CACES, délais, livraison, assurance, état des lieux, tarifs. Les réponses écrites
            noir sur blanc, sans zone d'ombre. Si la vôtre n'y figure pas, appelez-nous.
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <a href={ENTREPRISE.telephoneLien} className="btn-jaune">
              Appeler le {ENTREPRISE.telephone}
            </a>
            <Link to="/nos-engins" className="btn-contour">Voir le parc</Link>
          </div>
        </div>
        <Bande hauteur={6} />
      </section>

      <section className="bg-white py-12 sm:py-14">
        <div className="conteneur">
          <nav aria-label="Sommaire des questions" className="max-w-3xl">
            <ul className="flex flex-wrap gap-2.5">
              {categories.map((c) => (
                <li key={c}>
                  <a
                    href={`#${c.toLowerCase().replace(/[^a-zà-ÿ0-9]+/g, '-')}`}
                    className="inline-block font-cond uppercase tracking-[0.06em] text-[14px] bg-trame text-nuit px-3.5 py-2 border-l-2 border-bleu hover:border-jaune transition-colors"
                  >
                    {c}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </section>

      {categories.map((c, i) => (
        <section
          key={c}
          id={c.toLowerCase().replace(/[^a-zà-ÿ0-9]+/g, '-')}
          className={`${i % 2 === 0 ? 'bg-white' : 'bg-trame'} py-12 sm:py-14 scroll-mt-28`}
        >
          <div className="conteneur">
            <TitreSection avant={`${c.split(' ')[0]} `} mot={c.split(' ').slice(1).join(' ') || ''} />
            <div className="mt-7 max-w-3xl">
              <ListeFaq questions={FAQ.filter((f) => f.cat === c)} depart={-1} />
            </div>
          </div>
        </section>
      ))}

      <SectionContact
        avant="Votre question n'est pas "
        mot="là ?"
        intro="Posez-la directement. On répond en quelques heures, et si c'est urgent le téléphone reste le plus rapide."
      />
    </>
  );
}
